<div class="flex flex-col gap-8 animate-fadeIn">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
    <div class="flex-1 max-w-md">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search text-slate-400" />
        <input type="text" pInputText [formControl]="searchControl" [placeholder]="'search' | translate"
          class="w-full !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all" />
      </p-iconField>
    </div>

    <app-button *hasPermission="'Configurações:create'" label="{{ 'new_user' | translate }}" icon="pi pi-plus" variant="primary" (onClick)="onAddUser()">
    </app-button>
  </div>

  <!-- Table -->
  <app-prime-table [data]="users" [columns]="columns" [loading]="loading" [templates]="templates" [paginator]="false">
  </app-prime-table>

  <!-- Templates -->
  <ng-template #userTypeTpl let-item>
    <span *ngIf="item.user_type_name"
      [ngClass]="userTypeBadge.getClasses(item.user_type_id, item.user_type_name)"
      class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border shadow-sm">
      {{ item.user_type_name }}
    </span>
  </ng-template>

  <ng-template #nameTpl let-item>
    <div class="flex flex-col gap-0.5">
      <span class="font-medium text-slate-700 leading-tight">{{ item.name }}</span>
      <!-- Only shown while noteworthy — once fully active (logged in + password
           changed) the pill disappears so the list isn't cluttered with "Active"
           badges on every ordinary row. -->
      <span *ngIf="item.login_state && item.login_state !== 'active'" [ngClass]="{
          'bg-slate-50 text-slate-500 border-slate-100': item.login_state === 'not_logged_in',
          'bg-amber-50 text-amber-600 border-amber-100': item.login_state === 'pending_password_change'
        }" class="inline-block self-start leading-none px-1.5 py-0.5 rounded text-[9px] font-semibold uppercase tracking-wide border">
        {{ ('login_state_' + item.login_state) | translate }}
      </span>
    </div>
  </ng-template>

  <ng-template #statusTpl let-item>
    <div class="flex items-center">
      <span [ngClass]="{
          'bg-emerald-50 text-emerald-600 border-emerald-100': (item.status || '').toLowerCase() === 'ativo' || !item.status,
          'bg-rose-50 text-rose-600 border-rose-100': (item.status || '').toLowerCase() === 'inativo'
        }" class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border shadow-sm">
        {{ ((item.status || '').toLowerCase() === 'inativo' ? 'Inativo' : 'ativo') | translate }}
      </span>
    </div>
  </ng-template>

  <ng-template #actionsTpl let-item>
    <!-- Clinic owner (user_type_id 2): protected — disabled trigger, no menu -->
    <button *ngIf="item.user_type_id === 2" type="button" disabled
      [title]="'settings_user_owner_protected' | translate"
      class="p-2 text-slate-300 rounded-xl opacity-40 cursor-not-allowed">
      <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
      </svg>
    </button>

    <app-dropdown *ngIf="item.user_type_id !== 2 && (canEdit || canDelete)">
      <ng-template #trigger>
        <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
          </svg>
        </button>
      </ng-template>
      <ng-template #content>
        <div class="w-48 py-1">
          <button *hasPermission="'Configurações:edit'" (click)="onEdit(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="text-primary" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            {{ 'edit' | translate }}
          </button>

          <button *hasPermission="'Configurações:edit'" (click)="onToggleStatus(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <i class="pi"
              [ngClass]="((item.status || '').toLowerCase() === 'ativo' || !item.status) ? 'pi-user-minus text-amber-500' : 'pi-user-plus text-emerald-500'"
              style="font-size: 16px;"></i>
            {{ ((item.status || '').toLowerCase() === 'inativo' ? 'activate' : 'deactivate') | translate }}
          </button>

          <button *hasPermission="'Configurações:edit'" (click)="reissuePassword(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <i class="pi pi-key text-primary" style="font-size: 16px;"></i>
            {{ 'reissue_password_action' | translate }}
          </button>

          <button *hasPermission="'Configurações:delete'" (click)="openDeleteModal(item)" [disabled]="item.user_type_id === 3"
            [title]="item.user_type_id === 3 ? ('settings_user_doctor_no_delete' | translate) : ''"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-rose-600 hover:bg-rose-50 flex items-center gap-3 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="text-rose-500" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1v3M4 7h16" />
            </svg>
            {{ 'delete' | translate }}
          </button>
        </div>
      </ng-template>
    </app-dropdown>
  </ng-template>
</div>

<!-- Delete Confirmation Modal -->
<div *ngIf="showDeleteModal"
  class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
  <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
    <div class="p-10 text-center">
      <div class="w-20 h-20 rounded-full bg-rose-50 flex items-center justify-center mx-auto mb-8 text-rose-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h3 class="text-xl font-bold text-slate-800 mb-2">{{ 'confirm_delete' | translate }}</h3>
      <p class="text-sm text-slate-500 mb-10">{{ 'settings_user_delete_confirmation' | translate }}</p>

      <div class="flex justify-end gap-3">
        <app-button label="{{ 'cancel' | translate }}" variant="secondary" [disabled]="isDeletingUser"
          (onClick)="showDeleteModal = false"></app-button>
        <app-button label="{{ 'delete' | translate }}" variant="primary" (onClick)="confirmDelete()"
          [loading]="isDeletingUser" styleClass="!bg-rose-500 !hover:bg-rose-600 !border-rose-500" class="min-w-[100px]"></app-button>
      </div>
    </div>
  </div>
</div>

<!-- User Modal (Add/Edit) -->
<app-user-modal *ngIf="showUserModal" [user]="selectedUserForEdit" [branchId]="branchId" (close)="closeUserModal()"
  (saved)="onUserSaved()" (navigateToProfiles)="onNavigateToProfiles()"></app-user-modal>

<!-- Reissue temp password: confirm (this invalidates the current password) + reveal -->
<p-confirmDialog></p-confirmDialog>

<!-- In flight between confirming and the credential modal opening -->
<div *ngIf="isReissuing"
  class="fixed inset-0 bg-black/20 backdrop-blur-sm z-[9999] flex items-center justify-center">
  <div class="bg-white p-6 rounded-2xl shadow-xl flex flex-col items-center gap-3">
    <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
    <p class="font-black text-slate-800 uppercase tracking-tight text-sm">{{ 'reissue_password_loading' | translate }}</p>
  </div>
</div>

<app-credential-reveal-modal *ngIf="showCredentialModal" [visible]="showCredentialModal" [email]="reissuedEmail"
  [tempPassword]="reissuedTempPassword" [emailSent]="false" (closed)="onCredentialModalClosed()"></app-credential-reveal-modal>